import ItalicIcon from '@carbon/icons/es/text--italic/16';
import ItalicEditing from '@ckeditor/ckeditor5-basic-styles/src/italic/italicediting';
import { createCarbonIconPlugin } from './carbon-icon';

export const ITALIC = 'italic';
export const Italic = createCarbonIconPlugin({
  editing: ItalicEditing,
  name: 'Italic',
  uis: [
    {
      command: ITALIC,
      icon: ItalicIcon,
      label: 'Italic',
      keystroke: 'CTRL+I',
    },
  ],
});
